export const ONBOARDING_SOURCE = 'onboarding'
